export abstract class ChaUserDto {
  page: number;
  limit: number;
  field: string;
  order: string;
  filter: string;
}
